import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import DataWrapper from '../../principal/containers/DataWrapper';
import {TabelaProgramacao} from '../components/TabelaProgramacao';
import {TabelaProgramacaoMobile} from '../components/TabelaProgramacaoMobile';
import ProgramacaoNaviosStore from '../stores/ProgramacaoNaviosStore';
import FiltrosVisualizacaoStore from '../stores/FiltrosVisualizacaoStore';
import JanelaFiltros from '../../comum/components/JanelaFiltros';
import Footer from '../../comum/components/Footer'
import FooterOptions from '../../comum/components/FooterOptions'
import FooterContent from '../../comum/components/FooterContent'
import IconButton from '../../comum/components/IconButton'
import ModalAviso from "../../comum/components/ModalAviso"
import ExportarExcelProgramacaoNavios from "../components/ExportarExcelProgramacaoNavios"
import { makePDF } from '../../../utils/formatar';

@inject("store")
@DataWrapper
@observer
export class ProgramacaoNavios extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.naviosStore = new ProgramacaoNaviosStore();
        this.filtrosStore = new FiltrosVisualizacaoStore();

        this.handleCloseFilters = this.handleCloseFilters.bind(this)
        this.handleCancelFilters = this.handleCancelFilters.bind(this)
        this.handleOpenFilters = this.handleOpenFilters.bind(this)
        this.tabelasProgramacao = this.tabelasProgramacao.bind(this)
    }

    componentWillMount() {
        this.logging = false;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Programação de Navios");
        //this.appStore.showTopbar(true);
        // this.naviosStore.carregarLista();
    }

    componentWillUpdate() {
        if(this.naviosStore.situacaoBerco){
            this.tituloPaginaStore.setTitulo(process.env.rig ? "Berth Situation" : "Situação de Berço")
        }else if(this.naviosStore.mostrarFiltro){
            this.appStore.showTopbar(false);
            this.tituloPaginaStore.setTitulo("Customizar Visualização")
        }else{
            this.appStore.showTopbar(true);
            this.tituloPaginaStore.setTitulo("Programação de Navios")
        }
    }

    handleOpenFilters() {
        this.filtrosStore.carregarFiltros()
        this.naviosStore.clickFiltro()
    }

    handleCloseFilters() {
        this.filtrosStore.salvarFiltrosVisualizacao()
        this.filtrosStore.carregarFiltros()
        this.naviosStore.retornarParaTabela(this.filtrosStore.predefinicoes[this.filtrosStore.predefinicaoAtiva])
    }

    handleCancelFilters() {
        this.filtrosStore.cancelarClick()
        this.naviosStore.fecharFiltroSemSalvar()
    }

    handleAtualizar = () =>
    {
        this.naviosStore.mudarPeriodo();
    }
    
    tabelasProgramacao = () => {
        if(window.innerWidth > 991) {
            return <TabelaProgramacao ref={this.child} clickBtnFiltro={ this.handleOpenFilters } controller={ this.naviosStore } />
        } else {
            return <TabelaProgramacaoMobile ref={this.child} clickBtnFiltro={ this.handleOpenFilters } controller={ this.naviosStore } />
        }
    }

    render() {

        {/* TODO: - customizar caret-up caret-down (ordenar) do header da tabela
                  - exportar XLS, PDF e imprimir */ }

        const modalAviso = (
            <ModalAviso onClickFechar={ this.filtrosStore.sairLimiteDadosAtingido } >
                <h2>Opa! Limite ultrapassado.</h2>
                <p><label className="label-disabled">Você selecionou mais de <b>10 itens</b> <br></br> para exibir como Dados da tabela</label> </p>
                <p><label className="label-disabled"><span className="label-primary">Dica:</span> marque apenas os itens que <br></br> são importantes para você</label> </p>
            </ModalAviso>
        )

        const pdfData = this.naviosStore.todasColunas.filter(elem => this.naviosStore.filtrosAvancados.indexOf(elem.id) !== -1)
        const pdfDataTime = pdfData.filter(elem => elem.formatter && elem.formatter.name === 'formatarDataCustomHTML')
        return(
            <div>
                <div className="form-wrapper">
                    <div className={"content-panel"}>
                        {
                            !this.naviosStore.mostrarFiltro ?
                            this.tabelasProgramacao()
                            //<TabelaProgramacao ref={this.child} clickBtnFiltro={ this.handleOpenFilters } controller={ this.naviosStore } />
                            : 
                                <JanelaFiltros 
                                    closeAction = {this.handleCloseFilters}
                                    cancelButAction = {this.handleCancelFilters}
                                    controller = {this.filtrosStore}
                                    fields={['rowCards','checkbox','btn']}
                                    checkboxItems = {check}
                                    btnItems = {but}
                                    rowCardsItems = {cards}
                                    showWarningModal = {this.filtrosStore.mostrarLimiteDadosAtingido}
                                    warningModal = {modalAviso}
                                    editName = {this.filtrosStore.mostrarEditarPredefinicaoNome}
                                />
                        }
                    </div>
                </div>
                {!this.naviosStore.mostrarFiltro &&
                <Footer>
                    {/**Provavelmente pode ser criado um componente para isso */}
                    <FooterContent>
                        {this.naviosStore.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.naviosStore.total}</b> {this.naviosStore.total === 1 ? 'registro' :'registros'} -
                                    <a onClick={this.handleAtualizar}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>
                    
                    <FooterOptions>
                        <div>
                            {/* <ExportarPDFProgramacaoNavios controller = {this.naviosStore} /> */}
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.naviosStore.programacaoLista.length > 0 ? false : true}
                                onClick={() => makePDF(
                                    this.naviosStore.programacaoLista,
                                    pdfData.map(elem => elem.dataField),
                                    pdfData.map(elem => elem.text),
                                    pdfDataTime.map(elem => elem.dataField),
                                    [{input: 'NavioNome', append: 'Viagem'}],
                                    true
                                    )}
                            />
                        </div>
                        <div>
                            <ExportarExcelProgramacaoNavios controller={ this.naviosStore }/>
                        </div>
                    </FooterOptions>
                </Footer>}
            </div>
        );
    }
}

const check = {
    titulo:"Dados da tabela",
    itens:"todosDadosTabela",
    itensAtivos:"dadosTabelaAtivo",
    itensRequeridos: "dadosTabelaObrigatorios",
    onClickItem: "clickCheckboxLabel",
    limparTudo: "limparDadosTabela"
}

const but = {
    titulo: "Situação",
    itens:"todasSituacoes",
    itensAtivos:"situacoesAtivo",
    onClickItem:"situacaoClick"
}

const cards = {
    titulo: "Predefinições",
    container: "predefinicoes",
    ativo: "predefinicaoAtiva",
    onClick: "predefinicaoClick",
    editarClick: "editarPredeficaoNomeClick",
    editCancel:"cancelarNovoNome",
    editSave: "salvarNovoNome",
    editLabels:[
        {
            label:"Nome",
            value:"nome",
            onChange:"mudarNomePred"
        },
        {
            label:"Descrição",
            value:"descricao",
            onChange:"mudarDescPred"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/modules/programacao/containers/ProgramacaoNavios.js